export default function openMobileTopNav() {
  const isPresent = document.querySelector(".top-bar-nav-trigger");
  if (!isPresent) {
    return;
  }

  const hamburger = document.querySelector(".top-bar-nav-trigger");
  const menu = document.querySelector(".top-bar-nav-menu");

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
    menu.classList.toggle("is-open");
    document.body.classList.toggle("top-bar-nav-menu-open");
  });

  // Add this event listener to detect clicks outside the menu
  document.addEventListener("click", function (event) {
    // Check if the menu is open
    if (menu.classList.contains("is-open")) {
      // Check if the click was outside the menu and the hamburger button
      if (!menu.contains(event.target) && !hamburger.contains(event.target)) {
        // Close the menu
        hamburger.classList.remove("is-active");
        menu.classList.remove("is-open");
        document.body.classList.remove("top-bar-nav-menu-open");
      }
    }
  });

  function animateInMaxHeight(element) {
    function removeMaxHeight() {
      this.style.maxHeight = "none";
      this.removeEventListener("transitionend", transitionEndCallback);
      delete element._transitionEnd;
    }

    let transitionEndCallback = removeMaxHeight.bind(element);
    element._transitionEnd = transitionEndCallback;

    element.style.maxHeight = `${element.scrollHeight}px`;
    element.addEventListener("transitionend", transitionEndCallback);
  }

  function animateOutMaxHeight(element) {
    element.style.maxHeight = `${element.scrollHeight}px`;
    element.offsetHeight;

    if (element._transitionEnd) {
      element.removeEventListener("transitionend", element._transitionEnd);
    }

    setTimeout(function () {
      element.style.maxHeight = "0px";
    }, 1);
  }

  function openSubMenu() {
    const toggleTriggers = document.querySelectorAll(
      `.top-bar-nav-mobile .menu-item-has-children > a`
    );
    toggleTriggers.forEach((trigger) => {
      let toggle = trigger.nextElementSibling;

      toggle.classList.add("overflow-hidden");
      toggle.style.transition = `max-height 400ms`;

      function openItem() {
        trigger.classList.add("open");
        trigger.parentElement.classList.add("open");

        animateInMaxHeight(toggle);
      }

      function closeItem() {
        trigger.classList.remove("open");

        setTimeout(() => {
          trigger.parentElement.classList.remove("open");
        }, 300);

        animateOutMaxHeight(toggle);
      }

      trigger.addEventListener(
        "click",
        (e) => {
          e.preventDefault();

          if (trigger.classList.contains("open")) {
            closeItem();
          } else {
            openItem();
          }
        },
        false
      );
    });
  }

  openSubMenu();
}
